import * as Yup from 'yup'
import Flatpickr from "react-flatpickr"
import { FC, useEffect, useRef, useState } from "react"
import ReactDOM from "react-dom";
import { useDownloadSubmissionsModalContext } from "./DownloadSubmissionsModalContext";
import { ModalContainer } from "../../../helpers/components/generic/ModalContainer";
import { AwardSubmissionCsvColumns, AwardSubmissionInfo, AwardsApi, useAuthContext } from "@pull/pull-groupm-csp-api";
import { AwardDownloadSubmissionsModal } from "../model/_models";
import { getCountryRegionTagify, getTagsTagify } from '../../../helpers/functions/TagifyInstance'
import { useGlobalContext } from "../../../modules/core/GlobalContext";
import { useAwardSubmissionWinnerModalContext } from "./AwardSubmissionWinnerModalContext";
import { useFormik } from 'formik';
import clsx from 'clsx';
import { sharedDatePickerOptions } from '../../../Constants/DatepickerOptions';
import { QUERIES } from '../../../Constants/Queries';
import { useQueryClient } from 'react-query';
import { Success } from '../../../helpers/functions/SwalHelpers';
import { getErrorFromResponse } from '../../../helpers/functions/getErrorFromResponse';
import moment from 'moment';


const awardWinnerSchema = Yup.object().shape({
    winner: Yup.bool(),
    winnerDate: Yup.date().optional()
})


const AwardSubmissionWinnerModal: FC = () => {

    const { selectedValue, updateSelectedValue, showAwardSubmissionWinnerModal } = useAwardSubmissionWinnerModalContext()
    const [loading, setLoading] = useState(false)
	const queryClient = useQueryClient()
    const { getApiConfiguration } = useAuthContext()

    const awardSubmission = selectedValue?.awardSubmission as AwardSubmissionInfo
    const [awardSubmissionForEdit] = useState({
        id: awardSubmission.id,
        winner: awardSubmission.winner,
        winnerDate: awardSubmission.winner ? undefined : (awardSubmission?.winnerDate ?? undefined),
    })


    const formik = useFormik({
        initialValues: awardSubmissionForEdit,
        validationSchema: awardWinnerSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)

            const awardsApi = new AwardsApi(getApiConfiguration())
            try {
            	const response = await awardsApi.apiAwardsAwardSubmissionsPost({
                    id: values.id,
                    winnerSpecified: true,
                    winner: values.winner,
                    winnerDateSpecified: true,
                    winnerDate: values.winnerDate,
                    shortlistedSpecified: false
                })
            	setSubmitting(false)
            	if (response) {
                    console.log("Clearing:" + QUERIES.AWARDS.GET + awardSubmission.awardCategoryID);
            		queryClient.invalidateQueries([QUERIES.AWARDS.GET + awardSubmission.awardCategoryID])
            		queryClient.invalidateQueries([QUERIES.AWARDS.SEARCH + awardSubmission.awardCategoryID])
            		Success(`The award was successfully ${awardSubmissionForEdit.id === 0 ? "created" : "updated"}!`)
            		cancel()
            	}
            } catch (ex) {
            	if (ex as Response) {
            		const errorMessage = await getErrorFromResponse(ex as Response)
                    console.log(errorMessage);
            		//setError(errorMessage)
            	}
            	else {
            		console.log(ex)
            	}
            }
        },
    })

    useEffect(() => {
    }, [showAwardSubmissionWinnerModal, awardSubmission])

    if (!showAwardSubmissionWinnerModal)
        return <></>


    const cancel = () => {
        updateSelectedValue(null)
    }

    return (
        <ModalContainer id="kt_modal_judging_mark_winner" innerClassName="mw-650px">
            <form className="form" onSubmit={formik.handleSubmit} noValidate id="kt_modal_submissions_edit_award_details_form">
                <div className="modal-header" id="kt_modal_judging_mark_winner_header">
                    <h2>Mark as winner</h2>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span className="svg-icon svg-icon-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                            </svg>
                        </span>
                    </div>
                </div>
                <div className="modal-body py-10 px-lg-17">
                    <div className="scroll-y me-n7 pe-7" id="kt_modal_judging_mark_winner_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_submissions_edit_award_details_header" data-kt-scroll-wrappers="#kt_modal_submissions_edit_award_details_scroll" data-kt-scroll-offset="300px">

                        <div className="notice d-flex bg-light-primary rounded border-primary border mb-9 p-6">
                            <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                    <rect x="11" y="17" width="7" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
                                    <rect x="11" y="9" width="2" height="2" rx="1" transform="rotate(-90 11 9)" fill="currentColor"></rect>
                                </svg>
                            </span>
                            <div className="d-flex flex-stack flex-grow-1">
                                <div className="fw-semibold">
                                    <h4 className="text-gray-900 fw-bold">Information</h4>
                                    <div className="fs-6 text-gray-800">
                                        You can schedule when to mark the award as won or set it straight away from the options below.
                                        <br /><br />
                                        Scheduled dates use the UK timezone (GMT/BST)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row g-9 mb-8">
                            <div className="col-md-6 fv-row">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input {...formik.getFieldProps("winner")}  onClick={() => formik.setFieldValue("winnerDate", undefined)} className="form-check-input" type="checkbox" checked={(formik.values.winner)} id="setWin1" />
                                    <label className="form-check-label" htmlFor="setWin1">
                                        Set Winner immediately
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row g-9 mb-8">
                            <div className="col fv-row">
                                <label className="fs-6 fw-semibold mb-2" htmlFor="kt_modal_judging_mark_winner_date">Schedule win publish date</label>
                                <div className="position-relative d-flex align-items-center">
                                    <span className="svg-icon svg-icon-2 position-absolute mx-4">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                        </svg>
                                    </span>
                                    <Flatpickr data-enable-time {...formik.getFieldProps("judgingOpeningDate")}
										placeholder="Select a date"
										className="form-control form-control-solid ps-12 mb-lg-0 flatpickr-input"
										options={sharedDatePickerOptions}
										value={formik.values.winnerDate}
										onChange={(val: any) => {
											const date: Date = new Date(val[0])
											if (!isNaN(date.getTime())){
												formik.setFieldValue("winnerDate", moment(date).format("YYYY-MM-DDTHH:mm:ss"))
												formik.setFieldValue("winner", false)
                                            }
											else
												formik.setFieldValue("winnerDate", null)
												formik.setFieldValue("winner", false)
										}}
									/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer justify-content-end">
                    <div>
                        <button onClick={cancel} type="button" id="kt_modal_judging_mark_winner-cancel" data-bs-dismiss="modal" className="btn btn-light btn-color-gray-700 btn-active-color-info me-3">Cancel</button>
                        <button type="submit" 
                            disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                            id="kt_modal_judging_mark_winner_submit" className="btn btn-info">
                            <span className="indicator-label">Save and close</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                        </button>
                    </div>
                </div>
            </form>
        </ModalContainer>
    )

}

export { AwardSubmissionWinnerModal }

